import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconSquareFilled(props: IconProps) {
	return (
		<Icon fill="currentColor" {...props}>
			<path d="M19 2h-14a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z" />
		</Icon>
	);
}
